export default {
    top_menu: [
        {name:'Perkara utama',    id:0},
        {name:'persembahan-perniagaan', id:1},
        {name:'Memasak',  id:2},
        {name:'Politik',   id:3},
        {name:'+18',  id:4},
        {name:'Masyarakat',   id:5},
        {name:'Kesihatan',   id:6},
    ],
    read_other: 'Baca lebih lanjut',
    read_more:  'Baca lebih lanjut',
    not_found:  'Tiada apa-apa Dijumpai',
    read_also:  'Baca juga',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Hak cipta terpelihara.',
    subscribe: 'Langgan ke',

    thank_order: 'TERIMA KASIH ATAS PESANAN ANDA',
    specialist_contact: 'Pakar kami akan menghubungi anda tidak lama lagi, tunggu panggilan kami.',
    attention: 'Potongan harga dari rakan kongsi:',
    hurry: 'Cepat, masa pengaktifan diskaun adalah terhad! Anda hanya mempunyai <span id="time" class="time">30:00</span> minit untuk memilih salah satu produk unik ini:',

    hour_ago1: "Sejam yang lalu",
    hour_ago2: "beberapa jam yang lalu",
    hour_ago3: "beberapa jam yang lalu",
    new_publications: "Penerbitan baru",
    read: "Baca",
    today_at: "Hari ini di",
    author_names: ['James Wa','Michelle Yeoh','Henry Golding'],
    main_news: "Berita utama",
    leave_already: "Meninggalkan sudah? Tunggu, kami telah mengemas kini berita untuk anda",
    already_shared: "sudah dikongsi"

}